import flow from "lodash/fp/flow";
import { toObject } from "../../core/utils";
import identity from "lodash/fp/identity";
class UserVerificationsPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const formatToken = (user) => {
      if (user.verification_token) {
        const WEBSITEURL = process.env.WEBSITE_URL;
        user.verification_token = `${WEBSITEURL}verify_email.html?token=${user.verification_token}`;
      }

      return user;
    };

    return toObject(flow([formatToken, identity])(data));
  }
}

export default UserVerificationsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/userVerifications/userVerifications.transforms.js